import Flex from "@timeedit/ui-components/antd/flex/index";
import Spin from "@timeedit/ui-components/antd/spin/index";
import { PropsWithChildren, Suspense } from "react";
import { TComponent } from "../types/utils";

const LazyLoadWrapper: TComponent<PropsWithChildren> = ({ children }) => (
    <Suspense
        fallback={
            <Flex style={{ minHeight: 200 }} align="center" justify="center">
                <Spin />
            </Flex>
        }
    >
        {children}
    </Suspense>
);
export default LazyLoadWrapper;
